import { PICK_FAVORITES_QUEUE_UPDATE, PICK_FAVORITES_VIEW } from './types';

export const updatePickFavoritesQueue = (merchants, merchantsFiltered, favoriteMerchantIndex) => ({
  type: PICK_FAVORITES_QUEUE_UPDATE,
  merchants,
  merchantsFiltered,
  favoriteMerchantIndex,
});

export const triggerPickFavoritesIsViewed = () => ({
  type: PICK_FAVORITES_VIEW,
});
